<template>
    <div class="Login">
        <div class="Ligin-content">
            <div class="content_left_background">
                <div class="Login_form">
                    <div class="new-login">
                        <div class="login-box">
                            <!-- style="color:rgb(24,144,255); -->
                            <div class="login-copy">期刊后台管理系统</div>
                            <div class="login-form">
                                <div
                                    class="login-input"
                                    
                                >
                                    <input
                                        v-model="form.username"
                                        :class="Errorstate ? 'ErrorClasss' : ''"
                                        type="text"
                                        :style="
                                            EffectSwitchings
                                                ? ''
                                                : 'border: 2px solid #f0c54f;'
                                        "
                                        @click.stop="EffectSwitchin"
                                        @blur="LoseFocus"
                                    />
                                    <div
                                        :class="Errorstate ? 'ErrorClass' : ''"
                                        :style="
                                            EffectSwitching
                                                ? 'top: 50%;'
                                                : 'top: 0;color: rgb(229,151,0);font-weight: bold;'
                                        "
                                        class="input-cover"
                                    >
                                        账 号
                                    </div>
                                </div>
                                <div
                                    class="login-input"
                                >
                                    <input
                                        v-model="form.password"
                                        :class="
                                            Errorstate2 ? 'ErrorClasss' : ''
                                        "
                                        type="password"
                                        :style="
                                            EffectSwitchings2
                                                ? ''
                                                : 'border: 2px solid #f0c54f;'
                                        "
                                        @click.stop="EffectSwitchin2"
                                        @blur="LoseFocus2"
                                    />
                                    <div
                                        :class="Errorstate2 ? 'ErrorClass' : ''"
                                        :style="
                                            EffectSwitching2
                                                ? 'top: 50%;'
                                                : 'top: 0;color: rgb(229,151,0);font-weight: bold;'
                                        "
                                        class="input-cover"
                                    >
                                        密码（6到18位）
                                    </div>
                                </div>
                                <div
                                    class="login2ndStep"
                                >
                                </div>
                                <div class="login-actions">
                                    <div
                                        class="login-action-left"
                                    >
                                        {{ CErrorText }}
                                    </div>
                                    <div class="login-action-left">
                                        {{ EErrorText }}
                                    </div>
                                    <div class="login-action-right">
                                        <el-button
                                            v-loading="loading"
                                            class="submit"
                                            @click.stop="GetLongin"
                                        >
                                            <!-- 下一步 -->
                                            {{TextMsg}}
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_right_background"></div>
        </div>
    </div>
</template>

<script>
import { getToken } from "../utils/auth";
export default {
    data(){
        return{
            loading: false,
            // 输入框效果切换
            EffectSwitching : true,
            EffectSwitching2 : true,
            EffectSwitchings : true,
            EffectSwitchings2 : true,
            // 输入框层级
            Inputlevel : 1,
            CErrorText : "",
            EErrorText : "",
            Errorstate : false,
            Errorstate2 : false,
            TextMsg:"登录",
            // from表单
            form : {
                username:'',
                password:'',
            },
        }
    },
    created(){
        if(getToken()){
            this.$router.push({
                path: "/index",
            });
        }
        this.LoseFocus()
    },
    methods:{
        GetLongin(){
            // let CardNo_reg = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/
            // CardNo_reg.test(this.form.username):
            // this.$router.push({
            //     path: this.redirect || "/index",
            // });
            // return
            if (!this.form.username) {
                this.$message({
                message: "请输入账号",
                type: "warning",
                });
                return
            } else if (!this.form.password) {
                this.$message({
                message: "请输入密码",
                type: "warning",
                });
                return
            } else {
                this.$store
                .dispatch("Login", this.form)
                .then(() => {
                    console.log(123)
                    this.loading = false;
                    this.form = {};
                    this.$router.push({
                        path: "/index",
                    });
                })
                .catch(() => {
                    this.loading = false;
                });
            }
        },
        // 登录状态修改
        loginshows(){
            this.loginshow = true
            sessionStorage.setItem("liginstate", this.loginshow)
        },
        // 登录状态修改
        loginshowss() {
            this.loginshow = !this.loginshow
            sessionStorage.setItem("liginstate", this.loginshow)
        },
        // 登录页面状态保留
        LoginStateRetention(){
            switch (sessionStorage.getItem("liginstate")) {
                case "true":
                    return this.loginshow = true
                case "false":
                    return this.loginshow = false
                default:
                    return undefined
            }
        },
        // 账号输入框失去焦点(如果输入框有数据，就保留选中状态)
        LoseFocus(){
            if (this.form.username){
                this.EffectSwitching = false
                this.EffectSwitchings = false
                return
            }else{
                this.EffectSwitching = true
                this.EffectSwitchings = true
            }
        },
        // 密码框失去焦点
        LoseFocus2(){
            if (this.form.password){
                this.EffectSwitching2 = false
                this.EffectSwitchings2 = false
                return
            }else{
                this.EffectSwitching2 = true
                this.EffectSwitchings2 = true
            }
        },
        // 账号输入框点击事件
        EffectSwitchin(){
            this.EffectSwitching = false
            this.EffectSwitchings = false
            this.Errorstate = false
            this.CErrorText = ""
            this.EErrorText = ""
        },
        // 密码框点击事件
        EffectSwitchin2(){
            this.EffectSwitching2 = false
            this.EffectSwitchings2 = false
            this.Errorstate2 = false
            this.CErrorText = ""
            this.EErrorText = ""
        },
    }
};
</script>

<style lang="scss" scoped>
.el-input__icon {
    height: 58px; //设置高度，icon元素恢复原来的高度，这时arror才能垂直居中
    position: relative;
    top: -7px; // 元素整体上移，让箭头也居中
}
.Login {
    width: 100%;
    height: calc(100vh);
    .Ligin-content {
        width: 100%;
        height: 100%;
        background: aqua;
        display: flex;
        .content_left_background {
            flex: 1;
            background: url("../assets/imgs/bac.jpeg") no-repeat;
            background-size: cover;
            background-position: center;
            position: relative;
            .Login_form {
                position: absolute;
                top: 50%;
                left: 40%;
                left: 100%;
                width: 645px;
                height: 505px;
                background-color: rgba($color: #fff, $alpha: 1);
                z-index: 10;
                transform: translateY(-50%);
                transform: translate(-50%,-50%);
                box-shadow: 0 0 20px 0px #111;
                .new-login {
                    box-sizing: border-box;
                    width: 100%;
                    // height: calc(100% - 360px);
                    height: 605px;
                    display: flex;
                    -webkit-box-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    align-items: center;
                    font-family: AboutCopy, PingFangSC, sans-serif;
                    .login-box {
                        width: 100%;
                        height: 100%;
                        padding: 20px;
                        // border: 1px solid #e1e1e1;
                        border-radius: 6.5px;
                        position: relative;
                        .login-logo {
                            display: flex;
                            -webkit-box-pack: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            align-items: center;
                            padding: 20px 0 20px 0;
                            img {
                                // width: 252px;
                                width: 120px;
                            }
                        }
                        .login-copy {
                            // font-style: italic;
                            font-size: 32px;
                            font-weight: bold;
                            font-family: '微软雅黑';
                            display: flex;
                            -webkit-box-pack: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            align-items: center;
                            color: #000;
                            margin: 30px 0 90px 0;
                            padding: 0 10px;
                        }
                        .ConsumerAuthenticity{
                            position: absolute;
                            bottom: 20px;
                            left: 20px;
                            font-size: 20px;
                            font-weight: bold;
                            font-family: '微软雅黑';
                            display: flex;
                            -webkit-box-pack: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            align-items: center;
                            padding: 0 10px;
                            cursor: pointer;
                        }
                        .login-form {
                            display: flex;
                            -webkit-box-pack: center;
                            justify-content: center;
                            -webkit-box-align: center;
                            align-items: center;
                            -webkit-box-orient: vertical;
                            -webkit-box-direction: normal;
                            flex-flow: column;
                            padding: 0px 40px;
                            
                            .login-input {
                                box-sizing: border-box;
                                position: relative;
                                width: 100%;
                                margin-bottom: 20px;
                                input {
                                    box-sizing: border-box;
                                    text-align: left;
                                    padding: 0 40px 0 20px;
                                    font-size: 16px;
                                    height: 58px;
                                    line-height: 58px;
                                    border: 1px solid #e1e1e1;
                                    border-radius: 5px;
                                    color: #a1a1a1;
                                    width: 100%;
                                    outline: none;
                                }
                                .input-cover {
                                    // width: 140px;
                                    pointer-events: none;
                                    position: absolute;
                                    left: 0;
                                    top: 50%;
                                    transform: translateY(-50%);
                                    margin-left: 20px;
                                    padding: 5px;
                                    transition: 0.2s ease all;
                                    background: #fff;
                                    // background-color: rgba($color: #fff, $alpha: 0.7);
                                    color: #a1a1a1;
                                }
                                .ErrorClass {
                                    color: #ff4440 !important;
                                }
                                .ErrorClasss {
                                    border: 2px solid #ff4440;
                                }
                            }
                            .login2ndStep {
                                height: 17px;
                                font-size: 0.75rem;
                                font-weight: bold;
                                font-family: "PingFang SC", Arial,
                                    "Microsoft YaHei UI", "Microsoft YaHei",
                                    serif;
                                margin-top: 10px;
                                width: 100%;
                                text-align: right;
                                a {
                                    color: #cdcdcd;
                                    text-decoration: none;
                                }
                            }
                            .login-actions {
                                margin-top: 50px;
                                width: 100%;
                                display: flex;
                                -webkit-box-orient: horizontal;
                                -webkit-box-direction: normal;
                                flex-flow: row;
                                -webkit-box-pack: justify;
                                justify-content: space-between;
                                -webkit-box-align: center;
                                align-items: center;
                                .login-action-left {
                                    color: #ff4440;
                                }
                                .login-action {
                                    color: #cdcdcd;
                                    cursor: pointer;
                                }
                                .login-action-right {
                                    width: 100%;
                                    .submit {
                                        background: #fcd467;
                                        border: 1rpx solid rgba($color: #fcd467, $alpha: 0.5);
                                        width: 88px;
                                        width: 100%;
                                        height: 40px;
                                        // line-height: 40px;
                                        text-align: center;
                                        color: #4d4d4d;
                                        border-radius: 10px;
                                        font-family: "PingFang SC", Arial,
                                            "Microsoft YaHei UI",
                                            "Microsoft YaHei", serif;
                                        cursor: pointer;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .content_left_background::before {
            // margin-top: 80px;
            // height: calc(100vh - 80px);
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            // background-color: rgba(#FCC008, 0.9);
            // background-color: rgba(#fff, 0.2);
            z-index: 2;
        }
        .content_right_background {
            background: url("../assets/imgs/bac.jpeg") no-repeat;
            background-size: cover;
            background-position: center;
            // background: #222;
            flex: 1;
        }
    }
}
</style>